import * as React from 'react';

import { inject, observer } from 'mobx-react';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { UitkProgressBar } from 'uitk-react-progress-bar';
import { Localization, LocalizedComponentProps, withLocalization } from 'bernie-l10n';

export interface ReviewCountBarsProps extends LocalizedComponentProps {
  currentHotel?: CurrentHotelStore;
  l10n?: Localization;
}

@withLocalization
@inject('currentHotel')
@observer
export class ReviewCountBars extends React.Component<ReviewCountBarsProps> {
  public constructor(props) {
    super(props);
  }

  private computeTitle(rating, label) {
    return rating + ' - ' + label;
  }

  private getRatingBarOrDefault(rating, ratingCount, title) {
    const formattedTitle = this.computeTitle(rating, title);
    if (ratingCount) {
      return <RatingCountBar percent={ratingCount.percent} count={ratingCount.count.formatted} title={formattedTitle} />;
    } else {
      return <RatingCountBar percent={0} count="0" title={formattedTitle} />;
    }
  }

  public render() {
    const { currentHotel, l10n } = this.props;
    const { reviews } = currentHotel;
    const { ratingCounts } = reviews;

    const ratingCountsByRating = {};
    if (ratingCounts) {
      ratingCounts.forEach((value, index, arr) => {
        ratingCountsByRating[value.rating] = value;
      });
    }

    return (
      <>
        {this.getRatingBarOrDefault(5, ratingCountsByRating[5], l10n.formatText('hotels.infosite.reviews.superlative.excellent'))}
        {this.getRatingBarOrDefault(4, ratingCountsByRating[4], l10n.formatText('hotels.infosite.reviews.superlative.good'))}
        {this.getRatingBarOrDefault(3, ratingCountsByRating[3], l10n.formatText('hotels.infosite.reviews.superlative.okay'))}
        {this.getRatingBarOrDefault(2, ratingCountsByRating[2], l10n.formatText('hotels.infosite.reviews.superlative.mediocre'))}
        {this.getRatingBarOrDefault(1, ratingCountsByRating[1], l10n.formatText('hotels.infosite.reviews.superlative.poor'))}
      </>
    );
  }
}

interface RatingCountBarModel {
  percent: number;
  count: string;
  title: string;
}
const RatingCountBar = ({ percent, count, title }: RatingCountBarModel) => (
  <div className="uitk-cell all-b-padding-two">
    <UitkProgressBar percent={percent} progressDescription={count} title={title} />
  </div>
);
RatingCountBar['displayName'] = 'displayName';
